import { NamedRouteConfig } from './types';
import { TestPage } from '@/ui/pages/test/TestPage';
import { TestIconPage } from '@/ui/pages/test/TestIconPage';

export const testRoutes: NamedRouteConfig[] = [
  {
    path: '/test',
    name: 'test',
    component: TestPage,
  },
  {
    path: '/test-icon',
    name: 'test-icon',
    component: TestIconPage,
  },
];
